import styled from "styled-components";
import { getPropValue } from "./helpers";

export const FlexContainer = styled.div`
  display: flex;
  ${props => (props.wrap ? `flex-wrap: ${getPropValue(props.wrap)};` : "")}
  ${props =>
		props.alignItems ? `align-items: ${getPropValue(props.alignItems)};` : ""}
  ${props =>
		props.alignContent
			? `align-content: ${getPropValue(props.alignContent)};`
			: ""}
  ${props =>
		props.justifyContent
			? `justify-content: ${getPropValue(props.justifyContent)};`
			: ""}
  ${props =>
		props.justifySelf
			? `justify-self: ${getPropValue(props.justifySelf)};`
			: ""}
  ${props =>
		props.flexDirection
			? `flex-direction: ${getPropValue(props.flexDirection)};`
			: ""}
  ${props => (props.gap ? `gap: ${getPropValue(props.gap)};` : "")}
	${props =>
		props.marginTop ? `margin-top: ${getPropValue(props.marginTop)};` : ""}
  
  @media (min-width: 380px) {
    ${props =>
			props.wrap ? `flex-wrap: ${getPropValue(props.wrap, "sm")};` : ""}
    ${props =>
			props.alignItems
				? `align-items: ${getPropValue(props.alignItems, "sm")};`
				: ""}
    ${props =>
			props.alignContent
				? `align-content: ${getPropValue(props.alignContent, "sm")};`
				: ""}
  ${props =>
		props.justifyContent
			? `justify-content: ${getPropValue(props.justifyContent, "sm")};`
			: ""}
${props =>
	props.justifySelf
		? `justify-self: ${getPropValue(props.justifySelf, "sm")};`
		: ""}
${props =>
	props.flexDirection
		? `flex-direction: ${getPropValue(props.flexDirection, "sm")};`
		: ""}
${props => (props.gap ? `gap: ${getPropValue(props.gap, "sm")};` : "")}
  }

  @media (min-width: 768px) {
    ${props =>
			props.wrap ? `flex-wrap: ${getPropValue(props.wrap, "md")};` : ""}
    ${props =>
			props.alignItems
				? `align-items: ${getPropValue(props.alignItems, "md")};`
				: ""}
${props =>
	props.alignContent
		? `align-content: ${getPropValue(props.alignContent, "md")};`
		: ""}
${props =>
	props.justifyContent
		? `justify-content: ${getPropValue(props.justifyContent, "md")};`
		: ""}
${props =>
	props.justifySelf
		? `justify-self:${getPropValue(props.justifySelf, "md")};`
		: ""}
${props =>
	props.flexDirection
		? `flex-direction: ${getPropValue(props.flexDirection, "md")};`
		: ""}
${props => (props.gap ? `gap: ${getPropValue(props.gap, "md")};` : "")}
  }

  @media (min-width: 1024px) {
    ${props =>
			props.wrap ? `flex-wrap: ${getPropValue(props.wrap, "lg")};` : ""}
    ${props =>
			props.alignItems
				? `align-items: ${getPropValue(props.alignItems, "lg")};`
				: ""}
${props =>
	props.alignContent
		? `align-content: ${getPropValue(props.alignContent, "lg")};`
		: ""}
${props =>
	props.alignSelf ? `align-self: ${getPropValue(props.alignSelf, "lg")};` : ""}
${props =>
	props.justifyContent
		? `justify-content: ${getPropValue(props.justifyContent, "lg")};`
		: ""}
${props =>
	props.justifyItems
		? `justify-items: ${getPropValue(props.justifyItems, "lg")};`
		: ""}
${props =>
	props.justifySelf
		? `justify-self: ${getPropValue(props.justifySelf, "lg")};`
		: ""}
${props =>
	props.flexDirection
		? `flex-direction: ${getPropValue(props.flexDirection, "lg")};`
		: ""}
${props => (props.gap ? `gap: ${getPropValue(props.gap, "lg")};` : "")}
  }
`;
